export default {"src":"/_next/static/media/QUESTIONNAIRE_ACTIVE_ICON.f58abdc7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};